import validate from "/usr/src/app/content/n3-promos-7ce61de7-2c63-45c7-a765-73a8ac0162f5/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-7ce61de7-2c63-45c7-a765-73a8ac0162f5/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}